import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './GalleryClassic.css'; 

export default function GalleryClassic({ config }) {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section key="galeria" id="galeria" className="py-0 gallery-section">

      <div className="w-100 h-100">
        <div
          id="carouselBootstrap"
          className="carousel slide h-100"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner h-100">
            {config.galeria.carouselImages?.map((imagem, index) => (
              <div
                className={`carousel-item${index === 0 ? ' active' : ''} h-100`}
                key={index}
              >
                <img
                  src={imagem}
                  className="d-block w-100 h-100"
                  alt={`Imagem ${index + 1}`}
                  style={{
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%',
                    maxHeight: '100vh',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setSelectedImage(imagem);
                    setShowModal(true);
                  }}
                />
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselBootstrap"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Anterior</span>
          </button>
          <button
            className="carousel-control-next text-blue"
            type="button"
            data-bs-target="#carouselBootstrap"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Próximo</span>
          </button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Body className="p-0">
          <img
            src={selectedImage}
            alt="Imagem em destaque"
            style={{ width: '100%', height: 'auto', borderRadius: '0.5rem' }}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
}
